import { useEffect, useState } from 'react';
import useDropDownOptions from './useDropDownOptions';

const getVal = require('lodash/get');

const useMultiSelectDropDownOptions = (props) => {
  const { fieldId } = props;
  const options = useDropDownOptions({ ...props });
  const [modifiedOptions, setModifiedOptions] = useState([]);
  useEffect(() => {
    if (options?.length > 0) {
      options.forEach((option, index) => {
        // check if option object has a key as id if not then create a one
        if (!getVal(option, 'id')) {
          option.id = `${fieldId}-${index}`;
        }
      });
      setModifiedOptions(options);
    }
  }, [options]);
  return modifiedOptions;
};

export default useMultiSelectDropDownOptions;
